import SimulationsLabsVsCTFDPage from '@/components/SimulationsLabsVsCTFDPage';
import type { Route } from './+types/home';

export function meta({}: Route.MetaArgs) {
  return [
    { title: 'Simulations Labs vs CTFd: a better CTFd alternative' },
    {
      name: 'description',
      content:
        'Looking for a better CTFd alternative? Simulations Labs is a platform to create, manage, and run real-world cybersecurity simulations with scalable, fully managed environments',
    },
  ];
}

export default function SimulationsLabsVsCTFD() {
  return <SimulationsLabsVsCTFDPage />;
}
